import { Box, Flex } from "@chakra-ui/react";

interface propTypes {
  title: string;
  data: string;
}

function LandingStatCard({ title, data }: propTypes) {
  return (
    <Flex
      direction="column"
      flex="1"
      fontFamily="'IBM Plex Mono', monospace"
      borderRadius="sm"
      p="6"
      gap={1}
      bg="rgba(255, 255, 255, 1)"
    >
      <Box fontSize={["sm", "sm", "md", "md"]} fontWeight="medium">
        {title}
      </Box>
      <Box fontSize={["2xl", "2xl", "3xl", "2xl"]} fontWeight="semibold">
        {data}
      </Box>
    </Flex>
  );
}

export default LandingStatCard;
